import { Box, Container, Typography } from "@mui/material";
import OptimizedImage from "../ui/OptimizedImage";

function HeroSection() {
    return (
        <Box
            component="section"
            sx={{
                position: "relative",
                minHeight: {
                    xs: "100svh",
                    md: "100vh",
                },
                display: "flex",
                alignItems: {
                    xs: "flex-end",
                    md: "center",
                },
                overflow: "hidden",
                mt: {
                    xs: "-88px",
                    md: "-135px",
                },
                pt: {
                    xs: "88px",
                    md: "135px",
                },
                pb: {
                    xs: 5,
                    sm: 7,
                    md: 10,
                },
            }}
        >
            <OptimizedImage
                imageKey="src/assets/images/hero.jpg"
                alt=""
                priority
                sizes="100vw"
                sx={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                }}
                imgSx={{
                    width: "100%",
                    height: "100%",
                }}
                objectFit="cover"
                objectPosition={{
                    xs: "center top",
                    sm: "center center",
                    md: "center center",
                }}
            />

            <Box
                sx={{
                    position: "absolute",
                    inset: 0,
                    zIndex: 1,
                    background: `
                        linear-gradient(
                            180deg,
                            rgba(255, 255, 255, 0.18) 0%,
                            rgba(0, 0, 0, 0.18) 28%,
                            rgba(0, 0, 0, 0.72) 100%
                        )
                    `,
                    pointerEvents: "none",
                }}
            />

            <Container
                maxWidth={false}
                sx={{
                    position: "relative",
                    zIndex: 2,
                    width: "100%",
                    maxWidth: 1200,
                    mx: "auto",
                    px: {
                        xs: 2,
                        sm: 3,
                        md: 4,
                    },
                }}
            >
                <Box
                    sx={{
                        maxWidth: {
                            xs: 460,
                            md: 650,
                        },
                        color: "#fff",
                        pb: {
                            xs: 1,
                            md: 0,
                        },
                    }}
                >
                    <Typography
                        component="p"
                        sx={{
                            mb: 1.4,
                            fontFamily: '"Nunito Sans", sans-serif',
                            fontSize: {
                                xs: 13,
                                sm: 14,
                                md: 16,
                            },
                            fontWeight: 900,
                            letterSpacing: "0.18em",
                            textTransform: "uppercase",
                            color: "#1d76bd",
                            textShadow: "0 2px 12px rgba(0,0,0,0.35)",
                        }}
                    >
                        Hooksieler Lädchen
                    </Typography>

                    <Typography
                        component="h1"
                        sx={{
                            mb: {
                                xs: 2.2,
                                md: 3,
                            },
                            fontFamily: '"Quicksand", sans-serif',
                            fontSize: {
                                xs: "clamp(2.35rem, 11vw, 4rem)",
                                sm: 58,
                                md: 76,
                            },
                            lineHeight: {
                                xs: 1.02,
                                md: 0.98,
                            },
                            fontWeight: 700,
                            letterSpacing: "-0.055em",
                            textShadow: "0 5px 24px rgba(0,0,0,0.45)",
                        }}
                    >
                        Mode, Tee & Mee(h)r in Hooksiel
                    </Typography>

                    <Typography
                        sx={{
                            maxWidth: {
                                xs: 360,
                                md: 580,
                            },
                            mb: {
                                xs: 3.2,
                                md: 4.5,
                            },
                            fontFamily: '"Nunito Sans", sans-serif',
                            fontSize: {
                                xs: 17,
                                sm: 18,
                                md: 21,
                            },
                            fontWeight: 700,
                            lineHeight: {
                                xs: 1.45,
                                md: 1.6,
                            },
                            color: "rgba(255,255,255,0.96)",
                            textShadow: "0 3px 18px rgba(0,0,0,0.45)",
                        }}
                    >
                        Entdecken Sie maritime Mode, schöne Geschenkideen und ausgewählte
                        Teespezialitäten direkt im Herzen von Hooksiel.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
}

export default HeroSection;